import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import BlackClose from "./icons/BlackClose";

interface Props {
	show: boolean;
	onClose: () => void;
	children?: any;
	title?: string;
}

const Modal: React.FC<Props> = ({ show, onClose, children, title }) => {
	const [_document, setDocument] = useState<Document | null>(null);

	useEffect(() => {
		setDocument(document);
	}, []);

	const handleCloseClick = (e: any) => {
		e.preventDefault();
		onClose();
	};

	const modalContent = show ? (
		<StyledModalOverlay
			onClick={(e) => {
				e.stopPropagation();
				e.preventDefault();
				handleCloseClick(e);
			}}
		>
			<StyledModal
				onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
				}}
			>
				<StyledModalHeader>
					<div onClick={handleCloseClick} style={{ cursor: "pointer" }}>
						<BlackClose />
					</div>
				</StyledModalHeader>
				{title && <StyledModalTitle>{title}</StyledModalTitle>}
				<StyledModalBody>{children}</StyledModalBody>
			</StyledModal>
		</StyledModalOverlay>
	) : null;

	if (_document) {
		return ReactDOM.createPortal(modalContent, _document.getElementById("modal-root") as HTMLElement);
	} else {
		return null;
	}
};

const StyledModalBody = styled.div`
	padding: 20px 15px;

	.input-field {
		margin: 20px 0;
	}
`;

const StyledModalHeader = styled.div`
	display: flex;
	justify-content: flex-end;
`;

const StyledModalTitle = styled.div`
	font-size: 0.9rem;
	font-weight: 600;
	padding: 0 15px;
`;

const StyledModal = styled.div`
	background: white;
	width: 500px;
	border-radius: 15px;
	padding: 15px;
	margin: 1.5rem;
`;

const StyledModalOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.5);
`;

export default Modal;
